import { useQuery } from '@apollo/client/react';
import { StyleSheet, View } from 'react-native';
import { ActivityIndicator, Text } from 'react-native-paper';

import { DefaultAvatar } from '@/components/atoms';
import { MeDocument } from '@/generated/usermobile-bff/graphql';
import { useTranslation } from '@/i18n';
import { spacing, unisonColors, useAppTheme } from '@/theme';

export const ProfileCard = () => {
  const { t } = useTranslation();
  const { colors } = useAppTheme();
  const { data, loading, error } = useQuery(MeDocument);

  if (loading) {
    return (
      <View style={styles.tile}>
        <View style={styles.feedbackState}>
          <ActivityIndicator />
        </View>
      </View>
    );
  }

  if (error || !data?.me) {
    return (
      <View style={styles.tile}>
        <View style={styles.feedbackState}>
          <Text style={{ color: colors.error }}>{t('settings.profileError')}</Text>
        </View>
      </View>
    );
  }

  const { me } = data;

  return (
    <View style={styles.tile} testID="settings-profile-tile">
      <View style={styles.content}>
        <View style={styles.avatarCircle} testID="profile-avatar-circle">
          <DefaultAvatar size={48} />
        </View>
        <View style={styles.textContainer}>
          <Text style={[styles.name, { color: colors.textNdPrimary }]}>{me.name}</Text>
          <Text style={[styles.email, { color: colors.textNdSecondary }]}>{me.email}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  tile: {
    borderRadius: 8,
    paddingHorizontal: spacing[3],
    paddingVertical: spacing[1],
  },
  feedbackState: {
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: spacing[12],
  },
  content: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: spacing[2],
    paddingVertical: spacing[2],
  },
  avatarCircle: {
    alignItems: 'center',
    backgroundColor: unisonColors.borderNdBase,
    borderRadius: 24,
    height: 48,
    justifyContent: 'center',
    width: 48,
  },
  textContainer: {
    flex: 1,
    gap: 2,
  },
  name: {
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 22,
  },
  email: {
    fontSize: 14,
    lineHeight: 20,
    letterSpacing: 0.25,
  },
});
